import React, { Component } from 'react';
import DataTablesCreate from '../components/DataTablesCreate';
import { ApiClient, ApiResponse } from '../libs/apiClient';
import { DISPATCH_ID, SERVICE_RESPONSE, GET_MODAL_CARTA_PORTE_NAME } from '../libs/utils/Const';
import { connect } from 'react-redux';
import '../css/dataTables.css';
import $ from 'jquery';
import { Mercancia, ItemsPorte } from '../components/NewOrder';

//#region tableHeaders
const headersP = [
    { title: 'Código' },
    { title: 'Nombre' }
];

const headersF = [
    { title: 'N° doc.' },
    { title: 'Documento' },
    { title: 'Fecha' },
    { title: 'Días de atraso' },
    { title: 'Total' },
    { title: 'Saldo vencido' },
    { title: 'Pago Total' },
];

const headersTransfers = [
    { title: 'N° doc.' },
    { title: 'Documento' },
    { title: 'Fecha' },
    { title: 'Alm. Origen' },
    { title: 'Alm. Destino' },
    { title: 'Total' },
    { title: 'Pago Total' },
];

const headersTransporte = [
    { title: 'Código' },
    { title: 'Tipo de unidad' },
    { title: 'Placa VM' },
    { title: 'Tipo de transporte' },
];

const headersFiguraTransporte = [
    { title: 'Código' },
    { title: 'Nombre' },
    { title: 'Tipo' },
];
//#endregion

let apiClient = ApiClient.getInstance();
class ListPartnerModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchInTable: '',
        }

    }
    componentDidMount() {
        const { cleanData } = this.props;
        cleanData();
        this.closeAction();
    }

    //#region modalActions
    closeModal = async () => {
        $('#partnerList').modal('hide');
    };

    closeAction = () => {
        const { cleanData } = this.props;
        const state = this;
        $('#partnerList').on('hidden.bs.modal', () => {
            cleanData();
        });
    };
    //#endregion

    //#region renderPartner
    searchPartners = async (card = '', PageNumber) => {
        const { enableSpinner, type, refreshPartner, newOrderModel = {}, view = '' } = this.props;
        let newView = newOrderModel?.newView || view || '';
        let businesPartnerResponse;
        // if(card !== ''){
        businesPartnerResponse = await apiClient.getPartnerListCreate(type, card, PageNumber, newView);
        // }else{
        //     enableSpinner(true);
        //     businesPartnerResponse= await apiClient.getPartnerListCreate(type,card,PageNumber);
        //     enableSpinner(false);
        // }
        if (businesPartnerResponse.status === SERVICE_RESPONSE.SUCCESS) {
            refreshPartner(businesPartnerResponse.data.results, businesPartnerResponse.data.totalPage);
        }
    };
    renderPartner = () => {
        const { data, selectPartner, model, totalPage } = this.props;
        let CardCode = model.CardCode || '';
        return (

            <div className="modal fade bd-example-modal-lg modal-open scroll"
                id="partnerList"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div className="modal-dialog modal-lg modal-open" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                Socio de Negocios
                            </h4>
                            <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="table-responsive">
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                <tbody>
                                                    <DataTablesCreate data={data} totalPage={totalPage} headers={headersP} view={"partnerModal"} action={selectPartner} search={this.searchPartners} searchInTable={CardCode} />
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal} >Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
    //#endregion


    //#region renderInvoice
    // Agrega Datos de Factura de SAP al modelo 

    // selectItems = async (Items, arg)  => {
    //     const { model} = this.props;
    //     let arrayModel = [];
    //     let PesoBrutoTotal = 0;
    //     let NumTotalMercancias = 0;

    //     for(let i = 0; i < Items.length; i++){
    //         let itemModel = new Mercancia();
    //         itemModel.update                 = 1;
    //         itemModel.Index                  = Items[i].Index ;
    //         // cartaporte20:Mercancias:Mercancia
    //         itemModel.Descripcion            = Items[i].Dscription;
    //         itemModel.Cantidad               = Items[i].Quantity;
    //         itemModel.ClaveUnidad            = Items[i].unitMsr;
    //         itemModel.Unidad                 = Items[i].unitMsr;
    //         itemModel.Dimensiones            = Items[i].Height1 + '/' + Items[i].Width1 + '/' + Items[i].Length1
    //         itemModel.PesoEnKg               = Items[i].Weight1;
    //         itemModel.ValorMercancia         = Items[i].PriceBefDi;
    //         itemModel.Moneda                 = Items[i].Currency;
    //         arrayModel.push(itemModel);

    //         PesoBrutoTotal                   += Items[i].Weight1;
    //         NumTotalMercancias               += Items[i].Quantity;

    //         model.Ubicaciones[0].TipoUbicacion              = 'Origen';
    //         model.Ubicaciones[1].TipoUbicacion              = 'Destino';
    //         model.Ubicaciones[1].RFCRemitenteDestinatario   = Items[i].LicTradNum  || '';
    //         model.Ubicaciones[1].Calle                      = Items[i].Street      || '';
    //         model.Ubicaciones[1].NumeroExterior             = Items[i].StreetNo    || '';
    //         model.Ubicaciones[1].Estado                     = Items[i].State       || '';
    //         model.Ubicaciones[1].Pais                       = (Items[i].Country == 'MX') ? 'MEX' : Items[i].Country;
    //         model.Ubicaciones[1].CodigoPostal               = Items[i].ZipCode     || '';
    //     }

    //     model.Mercancias = arrayModel;
    //     model.DocEntry = arg != undefined ? arg.DocEntry.toString() : '';
    //     model.DocNum = arg != undefined ? arg.DocNum.toString() : '';
    //     model.PesoBrutoTotal = PesoBrutoTotal;
    //     model.NumTotalMercancias = NumTotalMercancias;    

    //     this.setState({
    //         checkboxArray: Items
    //     })
    // };
    // selectItemsToArray = async () =>{
    //     const {data} = this.props;
    //     const {checkboxArray} = this.state;
    //     let items = [];
    //     let invoiceList = [];
    //     let arg = {};
    //     for (let [id, value] of checkboxArray.entries()) {
    //         if (value) {
    //             arg = {
    //                 DocNum: data[id].DocNum,
    //                 DocEntry: data[id].DocEntry,
    //                 action: 'getInvoicesLines'
    //             }
    //             invoiceList = await apiClient.getInvoicesPorte(arg);
    //             for (let [id, value] of invoiceList.data.entries()) {
    //                 if (value) {
    //                     value.Index = id;
    //                     items.push(value);
    //                 }
    //             }
    //         }
    //     }
    //     this.selectItems(items, arg);
    //     this.closeModal();
    // };

    renderInvoice = () => {
        const { data, selectItemsToArray, selectItems, showAlert, search } = this.props;
        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll bgtransparent" role="dialog" id="partnerList" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">FACTURAS</h4>
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="table-responsive">
                                                <table className="table response" style={{ marginBottom: 0 }}>
                                                    <tbody>
                                                        <DataTablesCreate data={data} headers={headersF} view={"invoicesPaymentModal"} action={selectItems} showAlert={showAlert} flagInvoices={true} search={search} filterByDate={false} />
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal}>Cerrar</button>
                                <button type="button" className="btn botonCorrect" onClick={selectItemsToArray}>Agregar</button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.closeAction()}
            </div>
        )
    }
    //#endregion

    //#region renderTraslados
    renderTraslados = () => {
        const { data, selectItemsToArray, selectItems, showAlert, search } = this.props;
        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll bgtransparent" role="dialog" id="partnerList" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">DOCUMENTOS CREADOS POR CEDIS</h4>
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="table-responsive">
                                                <table className="table response" style={{ marginBottom: 0 }}>
                                                    <tbody>
                                                        <DataTablesCreate
                                                            data={data}
                                                            headers={headersTransfers}
                                                            view={"transferStock"} //transferStock 
                                                            action={selectItems}
                                                            showAlert={showAlert}
                                                            flagInvoices={true}
                                                            search={search}
                                                            filterByDate={false} />
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal}>Cerrar</button>
                                <button type="button" className="btn botonCorrect" onClick={selectItemsToArray}>Agregar</button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.closeAction()}
            </div>
        )
    }

    renderOutStockTransfersDocs = () => {
        const { data, selectItemsToArray, selectItems, showAlert, search, model } = this.props;
        const TITLE = GET_MODAL_CARTA_PORTE_NAME(model.SubTypeTransferDoc);
        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll bgtransparent" role="dialog" id="partnerList" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">{TITLE ?? ''}</h4>
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="table-responsive">
                                                <table className="table response" style={{ marginBottom: 0 }}>
                                                    <tbody>
                                                        <DataTablesCreate
                                                            data={data}
                                                            headers={headersF}
                                                            view={"invoicesPaymentModal"}
                                                            action={selectItems}
                                                            showAlert={showAlert}
                                                            flagInvoices={false}
                                                            search={search}
                                                            filterByDate={false}
                                                        />
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal}>Cerrar</button>
                                <button type="button" className="btn botonCorrect" onClick={selectItemsToArray}>Agregar</button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.closeAction()}
            </div>
        )
    }
    //#endregion

    //#region renderTransportes
    renderTransporte = () => {
        const { data, selectAction, showAlert, search } = this.props;
        return (
            <div>
                <div className="modal fade bd-example-modal-lg scroll bgtransparent" role="dialog" id="partnerList" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">Transportes</h4>
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="table-responsive">
                                                <table className="table response" style={{ marginBottom: 0 }}>
                                                    <tbody>
                                                        <DataTablesCreate data={data} headers={headersTransporte} view={"TransporteListModal"} action={selectAction} showAlert={showAlert} flagInvoices={true} search={search} filterByDate={false} />
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.closeAction()}
            </div>
        )
    }
    //#endregion

    //#region renderFiguraTransportes
    renderFiguraTransporte = () => {
        const { data, selectAction, showAlert, search } = this.props;
        return (
            <div>
                <div className="modal fade bd-example-modal-lg scroll bgtransparent" role="dialog" id="partnerList" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">Figuras de transporte</h4>
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="table-responsive">
                                                <table className="table response" style={{ marginBottom: 0 }}>
                                                    <tbody>
                                                        <DataTablesCreate data={data} headers={headersFiguraTransporte} view={"FiguraTransporteListModal"} action={selectAction} showAlert={showAlert} flagInvoices={true} search={search} filterByDate={false} />
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.closeAction()}
            </div>
        )
    }
    //#endregion

    render() {
        const { data, modalView } = this.props;
        if (data.length === 0) { return <div className="modal fade bd-example-modal-lg scroll bgtransparent" id="partnerList"></div>; }

        return (
            <div>
                {modalView && modalView === 'I' && this.renderInvoice()}
                {modalView && modalView === 'P' && this.renderPartner()}
                {modalView && modalView === 'T' && this.renderTraslados()}
                {modalView && modalView === 'outStockTransfersDocs' && this.renderOutStockTransfersDocs()}
                {modalView && modalView === 'TransporteListModal' && this.renderTransporte()}
                {modalView && modalView === 'FiguraTransporteListModal' && this.renderFiguraTransporte()}
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListPartnerModal);